"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldTreeView = void 0;
const core_api_1 = require("@ikegps/core-api");
const icon_1 = require("../../../components/icon");
const icons_1 = require("../../../components/icon/icons");
const theme_1 = require("../../../components/theme");
const i18n_1 = require("../../../i18n");
const mithril_1 = require("../../../mithril");
const form_palette_1 = require("../form.palette");
const form_field_tree_view_style_1 = require("./form.field.tree.view.style");
(0, theme_1.addStyles)(form_field_tree_view_style_1.Style);
class FormFieldTreeView {
    static view(editor) {
        const isSelected = editor.designer.selectedFieldId === editor.field.fieldId;
        const className = `${form_field_tree_view_style_1.CSS.container} ${isSelected ? form_field_tree_view_style_1.CSS.isSelected : ''}`;
        return (0, mithril_1.m)('div', { className }, FormFieldTreeView.viewButton(editor));
    }
    static viewForm(editor) {
        const children = [];
        for (const field of editor.field.fields) {
            children.push(editor.designer.viewField(field));
        }
        children.push(FormFieldTreeView.viewButtonNew(editor));
        return (0, mithril_1.m)('div', { className: form_field_tree_view_style_1.CSS.form.container }, [
            FormFieldTreeView.view(editor),
            (0, mithril_1.m)('div', { className: form_field_tree_view_style_1.CSS.form.children }, children)
        ]);
    }
    static viewButton(editor) {
        const isCloneable = editor.field.isCloneable;
        const isTitle = editor.field.title;
        const isLocked = editor.isLocked;
        const isSubtitle = editor.field.subtitle;
        const isHidden = editor.field.collector === core_api_1.IkeCollectorType.OFFICE;
        const isAdminOnly = editor.field.adminOnly;
        const isStatus = editor.field.isStatusField;
        const isRequired = editor.field.required;
        const isAddress = editor.field.isAddressLookupField;
        const isMapColor = editor.field.isMapColorField;
        let tags = null;
        if (isCloneable || isTitle || isLocked || isSubtitle || isHidden || isAdminOnly || isRequired || isStatus || isMapColor || isAddress) {
            tags = (0, mithril_1.m)('div', { className: form_field_tree_view_style_1.CSS.tag.list }, [
                isTitle ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.label,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_LABEL)
                }, 'L') : null,
                isSubtitle ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.label,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_SECONDARY_LABEL)
                }, 'SL') : null,
                isCloneable ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.cloneable,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_CLONEABLE)
                }, 'C') : null,
                isHidden ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.label,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_HIDE)
                }, 'H') : null,
                isAdminOnly ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.label,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_ADMIN_ONLY)
                }, 'A') : null,
                isStatus ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.status,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_STATUS)
                }, 'ST') : null,
                isMapColor ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.status,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_MAP_COLOR)
                }, 'M') : null,
                isLocked ? icon_1.Icon.view(icons_1.MaterialIcon.LOCK, {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.cloneable,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_LOCKED)
                }) : null,
                isRequired ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.label,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_REQUIRED)
                }, 'R') : null,
                isAddress ? (0, mithril_1.m)('div', {
                    className: form_field_tree_view_style_1.CSS.tag.tag + ' ' + form_field_tree_view_style_1.CSS.tag.label,
                    title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_ADDRESS)
                }, 'AD') : null
            ]);
        }
        let text = editor.field.displayName;
        if (text == null || text.trim().length === 0) {
            text = (0, i18n_1.Translate)(i18n_1.T.FIELD_DISPLAY_NAME_MISSING);
        }
        return (0, mithril_1.m)('button', {
            className: `mdl-button ${form_field_tree_view_style_1.CSS.title} ${editor.state.isValid ? '' : form_field_tree_view_style_1.CSS.isInvalid}`,
            onclick: () => editor.designer.setSelected(editor.field)
        }, [
            (0, mithril_1.m)('div', { className: form_field_tree_view_style_1.CSS.label.container }, [
                form_palette_1.FormDesignerPalette.viewIcon(editor.field.type, { className: form_field_tree_view_style_1.CSS.label.icon }),
                (0, mithril_1.m)('div', { className: form_field_tree_view_style_1.CSS.label.text, title: text }, text)
            ]),
            tags
        ]);
    }
    static viewButtonNew(editor) {
        const title = (0, i18n_1.Translate)(i18n_1.T.FORM_FIELD_ADD, { name: editor.field.displayName });
        return (0, mithril_1.m)('button', { className: `mdl-button ${form_field_tree_view_style_1.CSS.title}`, onclick: editor.addField }, [
            (0, mithril_1.m)('div', { className: form_field_tree_view_style_1.CSS.label.container }, [
                icon_1.Icon.view(icons_1.MaterialIcon.ADD, { className: form_field_tree_view_style_1.CSS.label.icon }),
                (0, mithril_1.m)('div', { className: form_field_tree_view_style_1.CSS.label.text, title }, title)
            ])
        ]);
    }
}
exports.FormFieldTreeView = FormFieldTreeView;
//# sourceMappingURL=form.field.tree.view.js.map